import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_FR_UQ || "uq.fr.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_FR_UQ || 24138,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_FR_UQ || 24139,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_FR_UQ ||
    "1:160978693362:web:44a3eb597678f73247346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-ES85DP7FQX" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.FR, LANGUAGE.EN],
  countryRegion: "Europe/Paris",
  timeZone: {
    [LANGUAGE.FR]: {
      defaultTimezone: "CEST",
      offset: {
        CET: 1,
        CEST: 2,
        "UTC+1": 1,
        "UTC+2": 2
      }
    },
    [LANGUAGE.EN]: {
      defaultTimezone: "CEST",
      offset: {
        CET: 1,
        CEST: 2,
        "GMT+1": 1,
        "GMT+2": 2
      }
    }
  },
  timeZoneParentCategory: {
    "GMT+1": "CET",
    "GMT+2": "CEST",
    "UTC+1": "CET",
    "UTC+2": "CEST"
  },
  dateFormat: {
    [LANGUAGE.FR]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: true
};

export default _countryEnv;
